import React, {useEffect, useState} from 'react';
import {OverlayModal} from '../OverlayModal';

import {
  ModalContainer,
  ModalContent,
  ModalBody,
  ModalTitle,
  ModalFooter,
  Grid,
  Row,
  Column,
  BankItem,
  BankImage,
  CheckItem,
  CheckItemContainer,
} from './styles';

import {Button} from '../../Interface/Forms/Buttons/Button';

interface IBankAlertModal {
  buttonAction: (bank: string) => void;
  isVisible: boolean;
  data: DataProps[];
  isLoading: boolean;
  onDismiss: () => void;
}

import {useTheme} from 'styled-components/native';

import {BankShimmer} from '../../Interface/Loadings/BankShimmer';

type DataProps = {
  id: {
    $oid: string;
  };
  nome: string;
  image_url: string;
};

export function BankAlertModal({
  buttonAction,
  data,
  isVisible,
  isLoading,
  onDismiss,
}: IBankAlertModal) {
  const theme = useTheme();

  const [bank, setBank] = useState('');

  function dismissModal() {
    setBank('');
    onDismiss();
  }

  const calculateColumns = () => {
    return data.length < 2 ? 1 : 2;
  };

  const renderRows = () => {
    const columns = calculateColumns();
    const rows = [];

    for (let i = 0; i < data.length; i += columns) {
      const rowItems = data.slice(i, i + columns);
      rows.push(<Row key={i}>{renderColumns(rowItems)}</Row>);
    }

    return rows;
  };

  const renderColumns = (rowItems: DataProps[]) => {
    return rowItems.map((item: DataProps, index: number) => (
      <Column key={index}>
        <BankItem
          active={bank === item.nome}
          activeOpacity={1}
          onPress={() => setBank(item.nome)}>
          <BankImage source={{uri: item.image_url}} resizeMode="contain" />
        </BankItem>
        {bank === item.nome && (
          <CheckItemContainer style={{alignItems: 'center'}}>
            <CheckItem name="check" />
          </CheckItemContainer>
        )}
      </Column>
    ));
  };

  return (
    <OverlayModal
      isVisible={data.length > 1 ? isVisible : false}
      onBackdropPress={dismissModal}
      onBackButtonPress={dismissModal}>
      <ModalContainer>
        <ModalContent>
          <ModalBody>
            <ModalTitle>
              Em qual banco você irá realizar o pagamento?
            </ModalTitle>

            {isLoading ? <BankShimmer /> : <Grid>{renderRows()}</Grid>}
          </ModalBody>
          <ModalFooter>
            <Button
              title="Continuar"
              enabled={bank !== ''}
              color={theme.colors.black}
              onPress={() => buttonAction(bank)}
            />
          </ModalFooter>
        </ModalContent>
      </ModalContainer>
    </OverlayModal>
  );
}
